<template>
  <div id="card-history">
    <div class="sav-card" v-for="(car, index) in cardData" :key="index">
        <div class="sav-card-header" :class="{ red: isExpired(car['end_date']), yellow: isGoingToExpire(cardData[0]['end_date']) }">
        <h2 class="sav-card-title">{{ cardHeader }}</h2>
      </div>
      <div class="sav-card-entries">
          <div class="sav-card-entry" v-for="(value, key, index) in car" v-show="key != 'id' && key != 'modified_date' && key != 'modified_by' && key != 'informed' && key != 'informed_date' && key != 'informed_by'" :key="index">
              <h3>{{ cardHeaders[key] }}</h3>
              <p v-if="key == 'start_date' || key == 'end_date'">{{ formatDate(value) }}</p>
              <a v-else-if="(key == 'docs_1' || key == 'docs_2' || key == 'docs_3' || key == 'docs_4')  && value" class="icon" target="_blank" :href="'/docs/' + value">
                Άνοιγμα εγγράφου
              </a>
              <p v-else-if="(key == 'docs_1' || key == 'docs_2' || key == 'docs_3' || key == 'docs_4')  && !value">Χωρίς έγγραφο</p>
              <p v-else>{{ value }}</p>
          </div>
      </div>

      <div v-if="isExpired(car['end_date']) && cardData[0]['informed']" class="sav-informed-checkbox">
        <h3>Ενημερώθηκε</h3>
      </div> 

      <div class="sav-card-footer">
        <span class="sav-card-log">Τελευταία αλλαγή στις {{ formatDate(cardData[0]['modified_date']) }} από {{ cardData[0]['modified_by'] }}</span>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: ['id', 'category', 'cardHeaders', 'cardData'],
  data() {
      return {
        name: 'Card',
				cardHeader: "Ασφάλεια"
      }
  },
  methods: {
    isExpired: function (date) {
      // true when date is in the past
      return new Date(date) < new Date()
    },
    isGoingToExpire: function (date) {
      // true when date is in the next 30 days
      let now = new Date(),
        nowPlus30 = new Date(),
        expirationDate = new Date(date);

      nowPlus30.setDate(now.getDate() + 30);
      return (expirationDate > now) && (expirationDate < nowPlus30) 
    },
    formatDate: function (date) {
      // format date dd/mm/yyyy
      let now = new Date(date);
      return this.sliceNumber(now.getDate(), 2) + "/" + this.sliceNumber(now.getMonth() + 1, 2) + "/" + this.sliceNumber(now.getFullYear(), 4)
    },
    sliceNumber: function(number, slice) {
      // return number with custom number of digits
      return ("0" + number).slice(-1 * slice);
    }
  },
	created: function() {
		// create card header depending on category
		if (this.category == 'car') {
				this.cardHeader = "Ασφάλεια Αυτοκινήτου"
		} else if (this.category == 'moto') {
				this.cardHeader = "Ασφάλεια Μηχανής"
		} else if (this.category == 'house') {
				this.cardHeader = "Ασφάλεια Κατοικίας"
		} else {
				this.cardHeader = "Ασφάλεια Υγείας"
		}
	}
}
</script>

<style lang="scss" scoped>
#card {
  margin-top: 20px;
}
</style>
